import { Box } from "@mui/material";
import SidebarLogout from "components/buttons/SidebarLogout/SidebarLogout";
import SidebarHeader from "../SidebarHeader/SidebarHeader";

export default function SidebarFooter({ mini }: { mini: boolean }) {
  return (
    <Box>
      <SidebarHeader mini={mini} />
      <SidebarLogout mini={mini} />
    </Box>
  );
}
